<template>
  <div class="">
    <div>
      <b-tabs content-class="pt-1" lazy v-model="tabIndex">
        <b-tab
          v-for="(tab, index) in tabs"
          :key="index"
          @click="onTabClick(tab, index)"
          :title="tab.text"
          :active="active(index)"
          title-item-class="lisaweb"
        >
          <keep-alive>
            <component :is="selected"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Brokers from "@/components/profile/import-maps/broker/index.vue";
import Treasuries from "@/components/profile/import-maps/treasury/index.vue";
import InsurerParticipant from "@/components/profile/import-maps/insurer-participant/index.vue";
import ShortcutsAndBreadcrumbsMixin from "@/mixins/ShortcutsAndBreadcrumbsMixin";

export default {
  mixins: [ShortcutsAndBreadcrumbsMixin],
  data() {
    return {
      path: "module.PROF.CONF",
      tabs: [
        { name: "Brokers", text: "Mappatura Produttori" },
        { name: "Treasuries", text: "Mappatura Forme di pagamento" },
        { name: "InsurerParticipant", text: "Mappatura Compagnia Coass" },
      ],
      tabsGroup: "Management",
      bcs: [
        {
          text: "Configurazione",
          path: "",
          level: 0,
          disabled: true,
        },
        {
          text: "Configurazione",
          path: "",
          level: 1,
        },
        {
          text: "Mappatura Importatori",
          path: "",
          level: 2,
        },
        {
          text: "Mappatura Produttori",
          path: "module.PROF.CONF",
          tab: `#${this.selected}`,
          level: 3,
        },
      ],
      maxLevel: 3,
      selected: "Brokers",
      tabIndex: 0,
    };
  },
  components: {
    Brokers,
    Treasuries,
    InsurerParticipant,
  },
};
</script>
